'use client';
/**
 * Builds the hub login URL with `return_to` set to the current page (or a
 * caller-provided alternative). Public so callers can keep all "navigate to
 * sign in" entry points pointed at the same canonical URL.
 */
export function getHubLoginUrl(opts = {}) {
    const here = currentReturnTo();
    const target = opts.returnTo ?? here;
    if (opts.hubBaseUrl) {
        const base = opts.hubBaseUrl.replace(/\/+$/, '');
        return `${base}/login?return_to=${encodeURIComponent(target || base)}`;
    }
    const path = target && /^https?:/i.test(target)
        ? new URL(target).pathname + new URL(target).search
        : target || '/';
    return `/login?return_to=${encodeURIComponent(path)}`;
}
function currentReturnTo() {
    if (typeof window === 'undefined')
        return '/';
    return window.location.origin + window.location.pathname + window.location.search;
}
/**
 * Top-level navigation to the hub's SSO logout. The hub clears tf_sso +
 * tf_refresh cookies (with Domain=<parent>) and 302s to `/login?return_to=`
 * so the user lands on a fresh form. Safe to call when the user is already
 * signed out — the route is auth-bypassed.
 */
export async function signOut(options = {}) {
    if (typeof window === 'undefined')
        return;
    const returnTo = typeof options.redirectTo === 'function'
        ? options.redirectTo()
        : options.redirectTo ?? currentReturnTo();
    const base = options.hubBaseUrl ? options.hubBaseUrl.replace(/\/+$/, '') : '';
    const target = `${base}/auth/sso/logout?return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = target;
}
//# sourceMappingURL=sign-out.js.map